import type { RootState } from '../../../store';

export const selectAuthState = (state: RootState) => state.auth;

/**
 * 로그인(인증) 완료 여부
 */
export const selectIsAuthenticated = (state: RootState) => state.auth.status === 'authenticated';

/**
 * 세션 정보를 반환
 */
export const selectSession = (state: RootState) => state.auth.session ?? state.auth.optimisticSession;
export const selectAuthStatus = (state: RootState) => state.auth.status;

/**
 * 인증된 사용자 정보를 반환
 */
export const selectAuthUser = (state: RootState) => state.auth.session?.user;

